import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';

function About() {
  return (
    <div className=' py-14'>
      <main className=" px-4 md:px-16">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          
          {/* Left side - About Ashok Maharaj Sirsat */}
          <div className="md:w-1/2 text-center md:text-left">
            <h1 className="text-3xl md:text-5xl text-orange-800 mb-6 font-yatra">
              यात्रा संयोजक परिचय
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed font-yatra">
              ह.भ.प. अशोक महाराज सिरसट हे अनेक वर्षांपासून वारकरी संप्रदायामध्ये 
              विशेष कार्य करत आहेत. त्यांनी विविध धार्मिक यात्रा अत्यंत श्रद्धा 
              आणि भक्तीभावाने आयोजित केल्या आहेत. यात्रेच्या प्रत्येक टप्प्याचे 
              काटेकोर नियोजन, यात्रेकरुंसाठी आवश्यक सोयी-सुविधा, तसेच धार्मिक 
              प्रवचने आणि कीर्तनाच्या माध्यमातून भक्तांना अध्यात्मिक आनंद देण्याचे 
              कार्य ते करतात. त्यांच्या मार्गदर्शनाखाली यात्रा अत्यंत यशस्वी आणि 
              मंगलमय वातावरणात पार पडते.
            </p>

            {/* Social Media Icons */}
            <div className="mt-6 flex justify-center md:justify-start gap-4 text-orange-500 text-3xl">
              <a href="https://www.facebook.com/share/16WYTeDdQH/" target="_blank" rel="noopener noreferrer" title="Facebook">
                <FaFacebook className="hover:text-blue-600 transition text-blue-600" />
              </a>
              <a href="https://www.instagram.com/sirsatashok?igsh=dTg2cDdyOHRmZ2N5" target="_blank" rel="noopener noreferrer" title="Instagram">
                <FaInstagram className="hover:text-pink-500 transition text-pink-500" />
              </a>
              <a href="https://youtube.com/@ashokmsirsat11?si=XUAK8o1MPBLg5MIm" target="_blank" rel="noopener noreferrer" title="YouTube">
                <FaYoutube className="hover:text-red-600 transition text-red-600 " />
              </a>
              <a href="https://wa.me/919552982935" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                <FaWhatsapp className="hover:text-green-600 transition text-green-600" />
              </a>
            </div>
            <p className="mt-4 text-lg text-gray-800 font-semibold">
    संपर्क: <a href="tel:9552982935" className="text-orange-700 hover:underline">9552982935</a>
  </p>
          </div>

          {/* Right side - Image and Name */}
          <div className="md:w-1/2 flex flex-col items-center">
            <img
              src="/Ashok_Sirsat_Maharaj_Photo.jpg"
              alt="ह.भ.प. अशोक महाराज सिरसट"
              className="w-full max-w-sm object-cover rounded-lg shadow-lg"
            />
            <h2 className="mt-4 text-2xl text-orange-800 font-yatra text-center md:text-left">
              ह.भ.प. अशोक महाराज सिरसट
            </h2>
          </div>
        </div>
      </main>
    </div>
  );
}

export default About;
